import { TextPage } from '../components/TextPage';

// Words approved by Warren for #175, and a public promise: change them only
// with his word, and change the date with them.
export function PrivacyPage() {
  return (
    <TextPage title="Privacy" updated="November 2, 2026">
      <p>
        Kudu keeps what a course needs: your name, email and institution, the
        courses you join, and your answers, scores, uploads and AI
        conversations.
      </p>
      <p>Your instructors and their assistants can see your work in their courses.</p>
      <p>Kudu does not sell your data.</p>
      <p>
        Other companies handle some of it for us: Google (hosting, sign-in and
        file storage), Stripe (course payments), OpenAI (what you type or upload
        to an AI feature) and YouTube (videos in a chapter).
      </p>
      <p>Kudu uses no advertising or analytics trackers.</p>
      <p>
        To ask about your data, or for a copy or its removal, write to{' '}
        <a href="mailto:support@kudu.com">support@kudu.com</a>.
      </p>
    </TextPage>
  );
}
